module.exports = __webpack_public_path__ + "img/check-old.52d9a038.png";